import { ROUTE_PATH } from "@/common/constants/routing";
import { AppPermission, LocationDto, LocationReferenceDto } from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import LocationInline, { LocationInlineProps } from "./LocationInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity?: LocationDto | LocationReferenceDto | null | undefined;
  entityId?: string | null;
  inlineProps?: Partial<LocationInlineProps>;
}

export default function LocationLink({ entity, entityId, inlineProps, ...otherProps }: Props) {
  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.LocationRead]}
      to={ROUTE_PATH.LOCATION_VIEW(entity?.id || entityId || "")}
      content={<LocationInline entity={entity} entityId={entityId} {...inlineProps} />}
      {...otherProps}
    />
  );
}
